import { render, staticRenderFns } from "./NewSolutionEditorComponent.vue?vue&type=template&id=77f07463&scoped=true"
import script from "./NewSolutionEditorComponent.vue?vue&type=script&lang=js"
export * from "./NewSolutionEditorComponent.vue?vue&type=script&lang=js"
import style0 from "./NewSolutionEditorComponent.vue?vue&type=style&index=0&id=77f07463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f07463",
  null
  
)

export default component.exports